export const VaultPermission = {
    Read: 'readonly-visible',
    Editor: 'editor',
    Owner: 'owner',
};

export const RecipientsPermission = [
    { key: VaultPermission.Read, name: 'Read' },
    { key: VaultPermission.Editor, name: 'Editor' },
    { key: VaultPermission.Owner, name: 'Owner' },
];

export const DELETE_VAULT_WITHOUT_RECIPIENTS = 'deleteVaultWithoutRecipients';
export const DELETE_VAULTS = 'deleteVault';
export const EDIT_VAULT = 'editVault';
